document.addEventListener('DOMContentLoaded', function () {
	const selectElement = document.getElementById('filterStaff');
	const filterByRoleElement = document.getElementById('filterStaffRoles');

	// Function to update the URL query string dynamically without overwriting existing parameters
	// Function to update the URL query string dynamically without overwriting existing parameters
	const updateUrlWithFilter = (baseUrl, filterParam, filterValue) => {
		// Create a new URL object with the current URL
		const url = new URL(window.location.href);

		// Set or update the specific query parameter (filter or role)
		url.searchParams.set(filterParam, filterValue);

		return url.toString(); // Return the updated URL
	};

	if (selectElement) {
		selectElement.addEventListener('change', function () {
			const selectedValue = selectElement.value.toLowerCase();
			const baseUrl = window.location.href.split('?')[0]; // Get the base URL without query string

			let newUrl;
			if (selectedValue === 'active') {
				newUrl = updateUrlWithFilter(baseUrl, 'filter', 'active');
			} else if (selectedValue === 'inactive') {
				newUrl = updateUrlWithFilter(baseUrl, 'filter', 'inactive');
			} else if (selectedValue === 'all') {
				newUrl = updateUrlWithFilter(baseUrl, 'filter', 'all');
			}

			window.location.href = newUrl;
		});
	}

	if (filterByRoleElement) {
		filterByRoleElement.addEventListener('change', function () {
			const selectedValue = filterByRoleElement.value.toLowerCase();
			const baseUrl = window.location.href.split('?')[0]; // Get the base URL without query string

			let newUrl;
			if (selectedValue === 'all') {
				newUrl = baseUrl; // No filter, just the base URL
			} else {
				newUrl = updateUrlWithFilter(baseUrl, 'role', selectedValue);
			}
			window.location.href = newUrl;
		});
	}
});